import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import ProjectQuotes from './project-quotes';
import { filterAnalyticsImportantQuotes } from '../../to-chart';
import { getQuotesByProjectId } from './graphql';
import KeyQuotes from '../question-types/key-quotes';

const AnalyticsQuotes = (props) => {
  const {
    project,
    segmentId,
    isDemoProject,
    history,
  } = props;
  const [quotes, setQuotes] = useState(null);
  const selectedSegment = segmentId === 'all' ? null : segmentId;

  useEffect(() => {
    async function fetchData() {
      const { quotes: quotesData } = await getQuotesByProjectId(project.id, selectedSegment);
      setQuotes(filterAnalyticsImportantQuotes(quotesData));
    }
    fetchData();
    // do not add project in the dependecy, it will duplicate requests when clicking on charts
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [segmentId, selectedSegment]);

  const mapSessionQuestions = useCallback(() => {
    let projectValue = project;
    let result = {};

    if (selectedSegment) {
      projectValue = project.segments.find((s) => s.id === undefined);
    }

    if (projectValue) {
      const { surveys } = projectValue;

      const questionArray = surveys.filter((s) => s.surveyType === 'session')[0] || {};

      if (questionArray.questions && Array.isArray(questionArray.questions)) {
        result = questionArray.questions.reduce((res, current) => {
          res[current.id] = current.label;
          return res;
        }, {});
      }
    }

    return result;
  }, [project, selectedSegment]);

  return (
    <>
      {
        quotes && (
          <KeyQuotes
            title="Important quotes we think you should know about"
            data={quotes}
            questions={quotes}
            questionsMap={mapSessionQuestions()}
            project={project}
            segmentId={selectedSegment}
          />
        )
      }

      <ProjectQuotes
        project={project}
        history={history}
        isDemoProject={isDemoProject}
        segmentId={selectedSegment}
      />
    </>
  );
};

export default AnalyticsQuotes;

AnalyticsQuotes.propTypes = {
  segmentId: PropTypes.string.isRequired,
  isDemoProject: PropTypes.bool.isRequired,
  project: PropTypes.shape({
    id: PropTypes.string,
    segments: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })).isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
};
